// extracted by mini-css-extract-plugin
export default {"provisionApp":"JmBQJz6lfuR1ff57scFg","heading":"BTqWq7IPoHwaPc7eBXPx","header":"AvmLRBTPkcXrGwROMm13"};